import CrmInfoView from "../crm_base/crm_info_view";
import {
    Eye,
    MousePointer,
    FileText,
    TrendingUp,
    Edit, Share, Download, PlusCircle
} from "lucide-react"
import { Button, StatsCard, Row, Col, ModifyModal, useCRUDController, Form, Input, Select, Checkbox, Radio, message, Modal } from "../ui/ot"
import dayjs from 'dayjs'
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useState, useEffect } from "react";
import BaseInfoView3 from "../ui/base_info_view_3";
import BaseInfoBlock2 from "../ui/base_info_block_2";
import BaseDocumentResponseCanvasEditModal from './../ui/base_document_response_canvas_edit_modal.jsx'
import AdvancedSearchForm from "../ui/advanced_search_form";

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 1.5rem;
  border-radius: 0.5rem;
  background: linear-gradient(
  to right,
  ${({ fromColor }) => fromColor || "#eef2ff"},
  ${({ toColor }) => toColor || "#f5f3ff"}
);
`;

const PageTitle = styled.h1`
  font-size: ${({ fontSize }) => fontSize || "1.875rem"};
  font-weight: ${({ fontWeight }) => fontWeight || "bold"};
  color: ${({ color }) => color || "#3730a3"};
  line-height: ${({ lineHeight }) => lineHeight || "1.2"};
`;
const CrmDashboard = ({
    propsReloadCount,
    propsSetReloadCount,
    propsReloadAndResetCount,
    propsSetReloadAndResetCount,
    rowKey,
    pageTitle = '管理首頁',
    createButtontext = "樣式建立",
    showCreateButtontext = true,
    createApiRoute = '',
    createFrontendRoute = null,
    primaryColor = '#6366f1',
    secondColor = '#a855f7',
    pageTitleColor,
    pageTitleFontSize = '1.875rem',
    pageTitleFontWeight = 700,
    pageTitleLineHeight = '1.2',
    createButtonTextColor = '#ffffff',
    createButtonFontSize = '14px',
    createButtonFontWeight = 500,
    descriptionColor = '#475569',
    descriptionFontSize = '14px',
    descriptionLineHeight = '1.7',
    apiRoute = "/custom_page_layout_and_file_management/backend/template",
    propsGetBaseCardViewData,
    propsGetBaseListViewData,
    createMode = "page", // "modal"||"page" // 建立資料的方式 modal 直接跳出modal 換頁新增 
    axiosMode = "post", // post patch 給create mode 是 modal 用的
    responseApi = "/utility/response/cache",
    formColumnApi = "/utility/form/newest",
    baseCardView1_2PropsSrc = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKFSgdhQvBlZO6I8s-jtKIYOED1NqEs4xEjA&s", // 顯示預設圖片
    stats = [{
        value: 90,
        label: "總範本數",
        color: "#6366f1",
        backgroundColor: "bg-white",
        icon: <FileText />,
        iconPosition: "right",
        animationDuration: 2000,
        animationDelay: 0,
        change: {
            value: "+12% 較上週",
            type: "increase",
        },
    },
    {
        value: 12,
        label: "系統範本",
        color: "#3b82f6",
        backgroundColor: "bg-white",
        icon: <PlusCircle />,
        iconPosition: "right",
        animationDuration: 1800,
        animationDelay: 200,
        change: {
            value: "+12% 較上週",
            type: "increase",
        },
    },
    {
        value: 12,
        label: "系統範本",
        color: "#3b82f6",
        backgroundColor: "bg-white",
        icon: <PlusCircle />,
        iconPosition: "right",
        animationDuration: 1800,
        animationDelay: 200,
    },
    {
        value: 12,
        label: "系統範本",
        color: "#3b82f6",
        backgroundColor: "bg-white",
        icon: <PlusCircle />,
        iconPosition: "right",
        animationDuration: 1800,
        animationDelay: 200,
    }
    ],
    statsProps = {},
    showBaseInfoView3 = false,
    tabsData = [
        {
            key: "empty_draft",
            label: "進行中/歷史 空白建立",
            total: "0/0", // 雙數字
            badgeClassname: "bg-[#8d96f9]/75 text-[#8d96f9]",
            apiRoute: apiRoute
        },
        {
            key: "ai_generated",
            label: "進行中/歷史 AI生成",
            total: "0/0",
            badgeClassname: "bg-[#8d96f9]/75 text-[#8d96f9]",
            apiRoute: apiRoute
        },
        {
            key: "system_default",
            label: "進行中/歷史 系統預設",
            total: "5/0/500", // 三段數字
            badgeClassname: "bg-[#8d96f9]/75 text-[#8d96f9]",
            apiRoute: apiRoute
        }],
    onSelectTabKey = () => { },
    tabsDataProps = {},
    PreviewModal = {},
    showTreeFilter = false,
    FilterComponent = <></>,
    multipleEditComponent = <></>,
    showCardContent = false,
    FilterComponentCols = 6,
    CardContentData = <></>,
    importButton = false,
    treeFilterTitle = "分類篩選",
    searchTextConfig = {},
    viewModeTextConfig = {},
    categoryTabTextConfig = {},
    formColumnApiParams = {},
    showBaseInfoBlock2 = false,
    showHeaderContainer = true,
    showStatsCard = true,
    showDescription = true,
    showCreateAction = true,
    showContentSection = true,
    editModal = false,
    processResponseData,
    columnsPerRow = 4,
    propsDescription = null,  // 新增
    buttonGroupsColumnsCount = [2, 3],
    ...props
}) => {
    const finalFrontendRoute = createFrontendRoute ?? createApiRoute
    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [reloadCount, setReloadCount] = useState(0)
    const [reloadAndResetCount, setReloadAndResetCount] = useState(0)
    const [showTabsKey, setShowTabsKey] = useState(tabsData?.find(_ => true)?.key)
    const form = Form.useForm();
    const getBaseCardViewData = (data) => {
        let newdata = data.map((value) => {
            let template_classify_structure_type_data = value?.template_classify_structure_type_data || []
            let template_classify_structure_type_data_first = template_classify_structure_type_data?.find((ele) => true)
            let name_language_data = template_classify_structure_type_data_first?.name_language_data || []
            let twName = name_language_data?.find((ele) => ele?.language_culture_code === "zh-tw")?.language_culture_value

            return {
                key: value?.key,
                baseCardView1_1Props: {
                    checked: false,
                    onCheckedChange: () => { }
                },
                baseCardView1_2Props: {
                    src: baseCardView1_2PropsSrc
                    // src: "https://open.ncl.edu.tw/pic/room/636869e192c94.jpg"
                },
                baseCardView1_3Props: {
                    value: twName,
                },
                baseCardView1_4Props: {
                    value: value?.template_description,
                },
                baseCardView1_5Props: {
                    stats: [
                        {
                            value: value?.view_times || 0,
                            label: "瀏覽次數",
                            backgroundColor: "bg-blue-50",
                            animationDuration: 2000,
                            animationDelay: 0,
                            icon: <Eye className="h-4 w-4 text-blue-500" />
                        },
                        {
                            value: value?.clone_times || 0,
                            label: "撰寫文案",
                            backgroundColor: "bg-green-50",
                            animationDuration: 1500,
                            animationDelay: 200,
                            icon: <FileText className="h-4 w-4 text-green-500" />
                        },
                        {
                            value: value?.click_times || 0,
                            label: "點擊次數",
                            backgroundColor: "bg-blue-50",
                            animationDuration: 2000,
                            animationDelay: 0,
                            icon: <MousePointer className="h-4 w-4 text-purple-500" />

                        },
                        {
                            value: value?.copy_times || 0,
                            label: "複製次數",
                            backgroundColor: "bg-green-50",
                            animationDuration: 1500,
                            animationDelay: 200,
                            icon: <TrendingUp className="h-4 w-4 text-orange-500" />

                        },
                    ]
                },
                baseCardView1_6Props: {
                    badges: [
                        {
                            label: value?.create_user_name ?? value?.create_user_id,
                            variant: "outline",
                            className: ""
                        },
                        {
                            label: dayjs(value?.create_time).format("YYYY-MM-DD"),
                            variant: "outline",
                            className: ""
                        },
                    ]
                },
                baseCardView1_7Props: {
                    children: <p className="text-gray-600 mt-1 text-sm">儲存位置：.../.../...</p>
                },
                baseCardView1_8Props: {
                    buttons: [
                        <Button variant="outline" className="flex-1">
                            <Eye className="h-4 w-4 mr-1" />
                            查看
                        </Button>,
                        <Button className="flex-1">
                            <Edit className="h-4 w-4 mr-1" />
                            複製文案內容並編輯
                        </Button>,
                        <Button variant="ghost" size="sm">
                            <Share className="h-4 w-4 mr-1" />
                            分享
                        </Button>,
                        <Button variant="ghost" size="sm">
                            <Download className="h-4 w-4 mr-1" />
                            匯出
                        </Button>,
                        <Button variant="ghost" size="sm" className="text-red-600">
                            刪除
                        </Button>,
                    ],
                    buttonGroupsColumnsCount: buttonGroupsColumnsCount,
                },
            }
        })
        return newdata
    }
    const getBaseListViewData = (data) => {
        let newdata = data.map((value) => {
            let template_classify_structure_type_data = value?.template_classify_structure_type_data || []
            let template_classify_structure_type_data_first = template_classify_structure_type_data?.find((ele) => true)
            let name_language_data = template_classify_structure_type_data_first?.name_language_data || []
            let twName = name_language_data?.find((ele) => ele?.language_culture_code === "zh-tw")?.language_culture_value

            return {
                key: "1",
                baseListView1_1Props: {
                    checked: false,
                    onCheckedChange: () => { }
                },
                baseListView1_2Props: {
                    value: twName,
                },
                baseListView1_3Props: {
                    value: value?.template_description,
                },
                baseListView1_4Props: {
                    stats: [
                        {
                            value: 1250,
                            label: "瀏覽次數",
                            backgroundColor: "bg-blue-50",
                            animationDuration: 2000,
                            animationDelay: 0,
                            icon: <Eye className="h-4 w-4 text-blue-500" />
                        },
                        {
                            value: 45,
                            label: "撰寫文案",
                            backgroundColor: "bg-green-50",
                            animationDuration: 1500,
                            animationDelay: 200,
                            icon: <FileText className="h-4 w-4 text-green-500" />


                        },
                        {
                            value: 320,
                            label: "點擊次數",
                            backgroundColor: "bg-blue-50",
                            animationDuration: 2000,
                            animationDelay: 0,
                            icon: <MousePointer className="h-4 w-4 text-purple-500" />

                        },
                        {
                            value: 28,
                            label: "複製次數",
                            backgroundColor: "bg-green-50",
                            animationDuration: 1500,
                            animationDelay: 200,
                            icon: <TrendingUp className="h-4 w-4 text-orange-500" />

                        },
                    ]
                },
                baseListView1_5Props: {
                    badges: [
                        {
                            label: value?.create_user_name ?? value?.create_user_id,
                            variant: "outline",
                            className: ""
                        },
                        {
                            label: dayjs(value?.create_time).format("YYYY-MM-DD"),
                            variant: "outline",
                            className: ""
                        },
                    ]

                },
                baseListView1_6Props: {
                    children: <p className="text-gray-600 mt-1 text-sm">儲存位置：.../.../...</p>
                },
                baseListView1_7Props: {
                    buttons: [
                        <Button variant="outline" className="flex-1">
                            <Eye className="h-4 w-4 mr-1" />
                            查看
                        </Button>,
                        <Button className="flex-1">
                            <Edit className="h-4 w-4 mr-1" />
                            複製文案內容並編輯
                        </Button>,
                        <Button variant="ghost" size="sm">
                            <Share className="h-4 w-4 mr-1" />
                            分享
                        </Button>,
                        <Button variant="ghost" size="sm">
                            <Download className="h-4 w-4 mr-1" />
                            匯出
                        </Button>,
                        <Button variant="ghost" size="sm" className="text-red-600">
                            刪除
                        </Button>,
                    ],
                    buttonGroupsColumnsCount: buttonGroupsColumnsCount,
                },
            }
        })
        return newdata
    }
    const [tabKey, setTabKey] = useState("");
    const TabComponent = tabsData?.find(item => item?.key == showTabsKey)?.component

    return (
        <div className=" mx-auto ">
            <div className="flex flex-col space-y-2">
                {showBaseInfoBlock2 && <>
                    <BaseInfoBlock2
                        columnCount={4}
                    />
                </>}
                {showHeaderContainer && <>
                    <HeaderContainer fromColor={generateShadesFromHex(primaryColor)?.['50']} toColor={generateShadesFromHex(secondColor)?.['50']}>
                        <PageTitle
                            color={pageTitleColor || generateShadesFromHex(primaryColor)?.['800']}
                            fontSize={pageTitleFontSize}
                            fontWeight={pageTitleFontWeight}
                            lineHeight={pageTitleLineHeight}
                        >
                            {pageTitle}
                        </PageTitle>
                    </HeaderContainer>
                </>}
                {
                    createMode === "modal" &&
                    <>
                        {PreviewModal && showPreviewModal && (
                            <PreviewModal modalOpen={showPreviewModal} setModalOpen={setShowPreviewModal} selectedType={tabKey} />
                        )}
                        {editModal && <>
                            <BaseDocumentResponseCanvasEditModal
                                documentApiRoute={apiRoute}
                                formColumnApi={formColumnApi}
                                responseApi={responseApi}
                                open={modalOpen}
                                setOpen={setModalOpen}
                                axiosMode={"post"}
                                propsForm={form}
                                record={{
                                    document_id: showTabsKey
                                }}
                                formColumnApiParams={formColumnApiParams}
                                setReloadAndResetCount={setReloadAndResetCount}
                                setReloadCount={setReloadCount}
                                processResponseData={processResponseData}
                            />
                        </>}
                        {!editModal && <>
                            <CrmDashboardModal
                                formColumnApi={formColumnApi}
                                formColumnApiParams={formColumnApiParams}
                                responseApi={responseApi}
                                form={form}
                                modalOpen={modalOpen}
                                setModalOpen={setModalOpen}
                                axiosMode={axiosMode} // post patch
                                setReloadAndResetCount={() => {
                                    if (propsReloadAndResetCount) {
                                        return propsReloadAndResetCount(pre => pre + 1)
                                    }
                                    else {
                                        return setReloadAndResetCount(pre => pre + 1)
                                    }
                                }}
                                setReloadCount={() => {
                                    if (propsReloadCount) {
                                        return propsReloadCount(pre => pre + 1)
                                    }
                                    else {
                                        setReloadCount(pre => pre + 1)
                                    }
                                }}
                            />
                        </>}
                    </>
                }
                {showStatsCard && <>
                    <StatsCard
                        layout="horizontal"
                        stats={stats}
                        enableAnimation={false}
                        isLoading={false}
                        loadingDuration={1500}
                        size={'md'}
                        contentAlign={'left'}
                        backgroundColor={"bg-white"}
                        connection={'separated'}
                        columnsPerRow={columnsPerRow}
                        {...statsProps}
                    />
                </>}
                {/* 新增這一段 */}
                {showDescription && propsDescription && (
                    <div style={{ padding: '4px 0', color: descriptionColor, fontSize: descriptionFontSize, lineHeight: descriptionLineHeight }}>
                        {propsDescription}
                    </div>
                )}

                {showCreateAction && (
                    <Row>
                        <Col>
                            {createMode === "page" && showCreateButtontext && (!!finalFrontendRoute) && <Button
                            onClick={() => navigate(finalFrontendRoute)}
                            style={{
                                backgroundColor: generateShadesFromHex(primaryColor)?.['600'],
                                color: createButtonTextColor,
                                fontSize: createButtonFontSize,
                                fontWeight: createButtonFontWeight,
                            }}
                        >
                            <PlusCircle className="h-4 w-4" />
                            {createButtontext}
                        </Button>}

                            {createMode === "modal" && showCreateButtontext && <Button
                            onClick={() => {
                                setModalOpen(true)
                            }}
                            style={{
                                backgroundColor: generateShadesFromHex(primaryColor)?.['600'],
                                color: createButtonTextColor,
                                fontSize: createButtonFontSize,
                                fontWeight: createButtonFontWeight,
                            }}
                        >
                            <PlusCircle className="h-4 w-4" />
                            {createButtontext}
                        </Button>

                            }
                        </Col>
                    </Row>
                )}
                {showContentSection && TabComponent === undefined && <>
                    <CrmInfoView
                        {...(showBaseInfoView3 && showTabsKey ?
                            {
                                key: showTabsKey,
                                apiRoute: tabsData?.find(item => item?.key == showTabsKey)?.apiRoute,
                            } :
                            {
                                apiRoute: apiRoute
                            }
                        )}
                        getBaseCardViewData={propsGetBaseCardViewData ? propsGetBaseCardViewData : getBaseCardViewData}
                        getBaseListViewData={propsGetBaseListViewData ? propsGetBaseListViewData : getBaseListViewData}
                        baseInfoView5Props={{
                            baseInfoView5_1props: {
                                ...props?.baseInfoView5Props?.baseInfoView5_1props,
                                rowKey: rowKey
                            },
                            reloadCount: propsReloadCount ? propsReloadCount : reloadCount,
                            reloadAndResetCount: propsReloadAndResetCount ? propsReloadAndResetCount : reloadAndResetCount
                        }}
                        reloadCount={propsReloadCount ? propsReloadCount : reloadCount}
                        reloadAndResetCount={propsReloadAndResetCount ? propsReloadAndResetCount : reloadAndResetCount}
                        showTreeFilter={showTreeFilter}
                        FilterComponent={FilterComponent}
                        multipleEditComponent={multipleEditComponent}
                        showCardContent={showCardContent}
                        FilterComponentCols={FilterComponentCols}
                        CardContentData={CardContentData}
                        rowKey={rowKey}
                        treeFilterTitle={treeFilterTitle}
                        searchTextConfig={searchTextConfig}
                        viewModeTextConfig={viewModeTextConfig}
                        categoryTabTextConfig={categoryTabTextConfig}

                        {...props}
                    />
                </>}
                {showContentSection && TabComponent && <>
                    <TabComponent
                        {...(showBaseInfoView3 && showTabsKey ?
                            {
                                key: showTabsKey,
                                apiRoute: tabsData?.find(item => item?.key == showTabsKey)?.apiRoute,
                            } :
                            {
                                apiRoute: apiRoute
                            }
                        )}
                        getBaseCardViewData={propsGetBaseCardViewData ? propsGetBaseCardViewData : getBaseCardViewData}
                        getBaseListViewData={propsGetBaseListViewData ? propsGetBaseListViewData : getBaseListViewData}
                        baseInfoView5Props={{
                            baseInfoView5_1props: {
                                ...props?.baseInfoView5Props?.baseInfoView5_1props,
                                rowKey: rowKey
                            },
                            reloadCount: propsReloadCount ? propsReloadCount : reloadCount,
                            reloadAndResetCount: propsReloadAndResetCount ? propsReloadAndResetCount : reloadAndResetCount
                        }}
                        reloadCount={propsReloadCount ? propsReloadCount : reloadCount}
                        reloadAndResetCount={propsReloadAndResetCount ? propsReloadAndResetCount : reloadAndResetCount}
                        showTreeFilter={showTreeFilter}
                        FilterComponent={FilterComponent}
                        multipleEditComponent={multipleEditComponent}
                        showCardContent={showCardContent}
                        FilterComponentCols={FilterComponentCols}
                        CardContentData={CardContentData}
                        treeFilterTitle={treeFilterTitle}
                        searchTextConfig={searchTextConfig}
                        viewModeTextConfig={viewModeTextConfig}
                        categoryTabTextConfig={categoryTabTextConfig}


                        {...props}

                    />
                </>}
            </div>
        </div>

    )
}
function hexToHsl(hex) {
    hex = hex.replace('#', '');
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    const rPerc = r / 255;
    const gPerc = g / 255;
    const bPerc = b / 255;

    const max = Math.max(rPerc, gPerc, bPerc);
    const min = Math.min(rPerc, gPerc, bPerc);
    let h, s, l;

    l = (max + min) / 2;

    if (max === min) {
        h = s = 0; // achromatic
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case rPerc:
                h = (gPerc - bPerc) / d + (gPerc < bPerc ? 6 : 0);
                break;
            case gPerc:
                h = (bPerc - rPerc) / d + 2;
                break;
            case bPerc:
                h = (rPerc - gPerc) / d + 4;
                break;
        }
        h *= 60;
    }

    return [Math.round(h), Math.round(s * 100), Math.round(l * 100)];
}

function hslToHex(h, s, l) {
    s /= 100;
    l /= 100;
    const k = n => (n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = n =>
        Math.round(255 * (l - a * Math.max(-1, Math.min(k(n) - 3, 9 - k(n), 1))));
    return `#${f(0).toString(16).padStart(2, '0')}${f(8)
        .toString(16)
        .padStart(2, '0')}${f(4).toString(16).padStart(2, '0')}`;
}

function generateShadesFromHex(baseHex) {
    const [h, sBase, lBase] = hexToHsl(baseHex);

    const lightnessMap = {
        50: 95,
        100: 90,
        200: 80,
        300: 70,
        400: 60,
        500: 50,
        600: 40,
        700: 30,
        800: 20,
        900: 10,
    };

    const saturationMap = {
        50: 100,
        100: 100,
        200: 95,
        300: 90,
        400: 85,
        500: sBase,
        600: sBase,
        700: sBase - 10,
        800: sBase - 15,
        900: sBase - 20,
    };

    const result = {};
    for (const level of Object.keys(lightnessMap)) {
        const l = lightnessMap[level];
        const s = Math.max(40, Math.min(100, saturationMap[level]));
        result[level] = hslToHex(h, s, l);
    }
    result.DEFAULT = result[500];
    return result;
}

const CrmDashboardModal = ({
    modalOpen,
    setModalOpen,
    axiosMode,
    propsForm,
    formColumnApi = "/utility/form/newest",
    formColumnApiParams = {

    },
    responseApi = "/utility/response/cache",
    responseApiParams = {

    },
    propsRecord,
    setReloadAndResetCount = () => { },
    setReloadCount = () => { }
}) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_;
    const [documentValue, setDocumentValue] = useState(null);
    const [loading, setLoading] = useState(false);
    const responseController = useCRUDController({
        apiRoute: responseApi,
        onBefore: ({ axiosMode }) => {
            if (axiosMode !== "get") {
                setLoading(true);
            }
        },
        onFinish: ({ axiosMode, status, values }) => {
            if (status === "success") {
                if (axiosMode === "post") {
                    message.success("新增成功")
                    setReloadAndResetCount((pre) => pre + 1)
                } else if (axiosMode === "patch") {
                    message.success("修改成功")
                    setReloadCount((pre) => pre + 1)
                }
                else if (axiosMode === "delete") {
                    message.success("刪除成功")
                    setReloadAndResetCount((pre) => pre + 1)

                }
            }
            else if (status === "error") {
                if (axiosMode === "post") {
                    message.error("新增失敗")
                    setReloadAndResetCount((pre) => pre + 1)

                }
                else if (axiosMode === "patch") {
                    message.error("修改失敗")
                    setReloadCount((pre) => pre + 1)
                }
                else if (axiosMode === "delete") {
                    message.error("刪除失敗")
                    setReloadAndResetCount((pre) => pre + 1)
                }
            }
            if (axiosMode !== "get") {
                setLoading(false)
                setModalOpen(false);
            }
        }
    })
    const formColumnController = useCRUDController({ apiRoute: formColumnApi })
    const is_option = (component_type) => {
        let isArray = ['dropdown', 'checkbox', 'radio_button', 'multi_select_list']
        return isArray.includes(component_type) ? 1 : 0
    }
    useEffect(() => {
        formColumnController.getData({
            ...formColumnApiParams
        })
            .then((response) => {
                let data = response?.data || []
                let dataFirst = data.find(_ => true)
                setDocumentValue(dataFirst)
            })
            .catch(() => {

            })
    }, []);
    useEffect(() => {
        form.resetFields({
            recordset: propsRecord?.reaponseData ?? []

        });
        if (!!propsRecord && axiosMode === "patch") {
            form.resetFields({
                recordset: propsRecord?.reaponseData ?? []

            });
        }
        else {
            form.setFieldsValue({
                recordset: [
                    {

                    }
                ]
            });
        }
    }, [propsRecord])

    return (
        <Row>
            <Col span={24}>

                <ModifyModal
                    // title={<span>{axiosMode === "post" ? "新增資料" : "編輯資料夾"}</span>}
                    axiosMode={axiosMode}
                    propsForm={form}
                    // propsPatchOnBefore={propsPatchOnBefore}
                    // propsPatchonFinish={propsPatchonFinish}
                    PropsPatchForm={<CrmDashboardForm formColumnApi={formColumnApi} formColumnApiParams={{
                        document_id: propsRecord?.document_id,
                        ...formColumnApiParams
                    }} />}

                    // propsOnModalConfirm={propsOnModalConfirm}
                    propsUseData={() => {
                        return {
                            postData: (val) => {
                                let formResponseData = val?.find(_ => true)
                                let response_form_value_data =
                                    Object.keys(formResponseData)
                                        .filter((ele) => !ele.includes("response_form_value_id"))
                                        .map((key) => {
                                            let tempSplit = key.split("+")

                                            let value_type = tempSplit?.[0] //component type 0 1 逼不得
                                            let form_column_id = tempSplit?.[1]

                                            return {
                                                "form_column_form_value_data": [
                                                    {
                                                        "form_column_id": form_column_id
                                                    }
                                                ],
                                                "is_option": is_option(value_type),
                                                "value": {
                                                    "value": formResponseData[key]
                                                },
                                                "value_type": value_type
                                            }
                                        })
                                let postData = [
                                    {
                                        document_response_data: [
                                            {
                                                document_id: formColumnApiParams?.document_id ?? documentValue?.document_id
                                            }
                                        ],
                                        response_form_value_data
                                    }
                                ]

                                return responseController.postData(postData)
                            },
                            patchData: (val) => {

                                function transform(data) {
                                    const result = [];

                                    for (const key in data) {
                                        if (key.startsWith("response_form_value_id")) continue; // 跳過 id

                                        const [type, idx] = key.split("+");
                                        const response_form_value_id = data[`response_form_value_id+${idx}`];
                                        const value = data[key];

                                        let value_type = type;
                                        result.push({
                                            response_form_value_id,
                                            form_column_form_value_data: [
                                                {
                                                    form_column_id: Number(idx)
                                                }
                                            ],   // 看你需不需要
                                            index: Number(idx),
                                            value: { value },
                                            value_type,
                                            is_option: 0
                                        });
                                    }

                                    return result;
                                }
                                let formResponseData = val?.find(_ => true)
                                let response_form_value_data = transform(formResponseData)
                                let patchData = [
                                    {
                                        response_id: propsRecord?.response_id,
                                        response_form_value_data
                                    }
                                ]
                                return responseController.patchData(patchData)
                            },
                            deleteData: (val) => {

                            },
                        }
                    }}
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    initialValues={{
                        recordset: []
                    }}
                    // propsWidth={propsWidth}
                    // propsDefaultAxiosMode={propsDefaultAxiosMode}
                    formMode={true}
                    isMultipleEdit={false}
                // prefixRender={prefixRender}
                // propsPostTop={propsPostTop}
                />
            </Col>
        </Row>
    )
}

const CrmDashboardForm = ({
    propsForm,
    field,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    defaultValue = {},
    formColumnApi = '/utility/form/newest',
    formColumnApiParams,
}) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_;
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });

    };
    const onValuesChange = (value, { name, type }) => {
        let formValues = null;
        formValues = form.getFieldsValue();
    };

    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    useEffect(() => {
        setDataInitialization();
    }, []);
    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                formColumnApi={formColumnApi}
                                field={field}
                                form={form}
                                formColumnApiParams={formColumnApiParams}
                            />
                        </Col>
                    </Row>

                </Form>
            </Col>
        </Row>
    );
};
const FormItemComponent = ({
    field,
    initialValues = {},
    form,
    formColumnApi = "/utility/form/newest",
    formColumnApiParams,
    dropDownDocumentAPiRoute = "/utility/document/base_view"
}) => {
    const formColumnController = useCRUDController({ apiRoute: formColumnApi })
    const dropDownDocumentController = useCRUDController({ apiRoute: dropDownDocumentAPiRoute })
    const [formFormColumnData, setFormFormColumnData] = useState([])
    const [document_id, setDocumentId] = useState([])
    const renderSettingComponent = ({ type, setting }) => {

        if (type === "datetime") {
            return (
                <Input type="datetime-local" placeholder={setting?.placeholder} />
            );
        }
        else if (type === 'text-content') {
            return (
                <Input placeholder={setting?.placeholder} />
            );
        }
        else if (type === "number_input") {
            return (
                <Input type="number" placeholder={setting?.placeholder} />
            )
        }
        else if (type === "dropdown") {
            if (setting?.form_column_source_data) {

                return (
                    <Select
                        placeholder={setting?.placeholder}
                        options={setting?.form_column_selection_option_data.map((value) => {
                            let selection_option_classify_structure_type_data = value?.selection_option_classify_structure_type_data || []
                            let selection_option_classify_structure_type_data_first = selection_option_classify_structure_type_data.find(_ => true)
                            let name_language_data = selection_option_classify_structure_type_data_first?.name_language_data || []
                            let name_language_data_tw = name_language_data.find(_ => _.language_culture_code === "zh-tw")?.language_culture_value

                            return {
                                label: name_language_data_tw,
                                value: value?.selection_option_id
                            }
                        })}
                    />
                )
            } else {

                return (
                    <Select
                        placeholder={setting?.placeholder}
                        options={setting?.form_column_selection_option_data.map((value) => {
                            let selection_option_classify_structure_type_data = value?.selection_option_classify_structure_type_data || []
                            let selection_option_classify_structure_type_data_first = selection_option_classify_structure_type_data.find(_ => true)
                            let name_language_data = selection_option_classify_structure_type_data_first?.name_language_data || []
                            let name_language_data_tw = name_language_data.find(_ => _.language_culture_code === "zh-tw")?.language_culture_value

                            return {
                                label: name_language_data_tw,
                                value: value?.selection_option_id
                            }
                        })}
                    />
                )
            }
        }
        else if (type === "checkbox") {
            let options = setting?.form_column_selection_option_data.map((value) => {
                let selection_option_classify_structure_type_data = value?.selection_option_classify_structure_type_data || []
                let selection_option_classify_structure_type_data_first = selection_option_classify_structure_type_data.find(_ => true)
                let name_language_data = selection_option_classify_structure_type_data_first?.name_language_data || []
                let name_language_data_tw = name_language_data.find(_ => _.language_culture_code === "zh-tw")?.language_culture_value

                return {
                    label: name_language_data_tw,
                    value: value?.selection_option_id
                }
            })
            return (
                <Checkbox.Group
                    options={options}
                />
            )
        }
        else if (type === "radio_button") {
            let options = setting?.form_column_selection_option_data.map((value) => {
                let selection_option_classify_structure_type_data = value?.selection_option_classify_structure_type_data || []
                let selection_option_classify_structure_type_data_first = selection_option_classify_structure_type_data.find(_ => true)
                let name_language_data = selection_option_classify_structure_type_data_first?.name_language_data || []
                let name_language_data_tw = name_language_data.find(_ => _.language_culture_code === "zh-tw")?.language_culture_value

                return {
                    label: name_language_data_tw,
                    value: value?.selection_option_id
                }
            })
            return (
                <Radio.Group>
                    {options.map((option) => (
                        <Radio key={option.value} value={option?.value}>
                            {option?.label}
                        </Radio>
                    ))}
                </Radio.Group>
            )
        }
        else if (type === "datetime_picker") {
            return (
                <Input type="date" placeholder={setting?.placeholder} />
            )
        }
        else if (type === "multi_select_list") {
            return (
                <Select
                    placeholder={setting?.placeholder}
                    mode="multiple"
                    options={setting?.form_column_selection_option_data.map((value) => {
                        let selection_option_classify_structure_type_data = value?.selection_option_classify_structure_type_data || []
                        let selection_option_classify_structure_type_data_first = selection_option_classify_structure_type_data.find(_ => true)
                        let name_language_data = selection_option_classify_structure_type_data_first?.name_language_data || []
                        let name_language_data_tw = name_language_data.find(_ => _.language_culture_code === "zh-tw")?.language_culture_value

                        return {
                            label: name_language_data_tw,
                            value: value?.selection_option_id
                        }
                    })}
                />
            )
        }
        else if (type === "textarea") {
            return (
                <Input.TextArea placeholder={setting?.placeholder} />
            )
        }
        else if (type === "email_input") {
            return (
                <Input type="email" placeholder={setting?.placeholder} />
            )
        }
        else if (type === "phone_input") {
            return (
                <Input type="tel" placeholder={setting?.placeholder} />
            )
        }
        else if (type === "url_input") {
            return (
                <Input type="url" placeholder={setting?.placeholder} />
            )
        }
        else if (type === "password_input") {
            return (
                <Input type="password" placeholder={setting?.placeholder} />
            )
        }

    };
    useEffect(() => {
        formColumnController.getData({
            ...formColumnApiParams
        }).then((response) => {
            let data = response?.data || []
            let dataFirst = data.find(_ => true)
            let document_form_data = dataFirst?.document_form_data || []
            let document_form_data_first = document_form_data.find(_ => true)
            let form_form_column_data = document_form_data_first?.form_form_column_data || []
            setFormFormColumnData(form_form_column_data)
            setDocumentId(dataFirst?.document_id)
        })
    }, [])
    return (
        <Row>
            <Col span={24}>
                <Row>
                    {
                        formFormColumnData?.map((value) => {
                            let form_column_component_definitions_data = value?.form_column_component_definitions_data || []
                            let form_column_component_definitions_data_first = form_column_component_definitions_data.find(_ => true)
                            let component_type = form_column_component_definitions_data_first?.component_type

                            return <Col span={24} key={value?.form_column_id}>
                                <Form.Item
                                    labelCol={24}
                                    wrapperCol={24}
                                    name={[field.name ?? '', `${component_type}+${value?.form_column_id}`]}
                                    fieldKey={[field.fieldKey ?? '', `${component_type}+${value?.form_column_id}`]}
                                    label={value?.code}
                                    rules={
                                        [
                                            {
                                                required: !!value?.is_required,
                                                message: '此欄位為必填'
                                            }
                                        ]
                                    }
                                    extra={value?.help_text}
                                >
                                    {renderSettingComponent({ type: component_type, setting: value })}
                                </Form.Item>
                                <Form.Item
                                    labelCol={24}
                                    wrapperCol={24}
                                    name={[field.name ?? '', `response_form_value_id+${value?.form_column_id}`]}
                                    fieldKey={[field.fieldKey ?? '', `response_form_value_id+${value?.form_column_id}`]}
                                    label={`response_form_value_id+${value?.form_column_id}`}
                                    hidden={true}
                                >
                                </Form.Item>
                            </Col>
                        })
                    }

                </Row>
            </Col>
        </Row>
    );
};


export default CrmDashboard
export {
    CrmDashboardModal, CrmDashboardForm, FormItemComponent
}
